/**
 * Enum for airport location IDs used by the backend API
 */
export enum Locations {
    // New Zealand Airports (IDs 1-21)
    NZAA = 1,  // Auckland International Airport
    NZCH = 2,  // Christchurch International Airport
    NZDN = 3,  // Dunedin Airport
    NZHN = 4,  // Hamilton Airport
    NZWN = 5,  // Wellington International Airport
    NZQN = 6,  // Queenstown Airport
    NZNS = 7,  // Nelson Airport
    NZNP = 8,  // New Plymouth Airport
    NZPM = 9,  // Palmerston North Airport
    NZTG = 10, // Tauranga Airport
    NZRO = 11, // Rotorua Airport
    NZGS = 12, // Gisborne Airport
    NZNR = 13, // Napier Airport (Hawke's Bay)
    NZWR = 14, // Whangarei Airport
    NZHK = 15, // Hokitika Airport
    NZWB = 16, // Blenheim Airport
    NZTU = 17, // Timaru Airport
    NZNV = 18, // Invercargill Airport
    NZAP = 19, // Taupo Airport
    NZKK = 20, // Kerikeri Airport (Bay of Islands)
    NZOH = 21, // Ohakea Airport

    // United Kingdom Airports (IDs 22-66)
    EGLL = 22, // London Heathrow Airport
    EGKK = 23, // London Gatwick Airport
    EGCC = 24, // Manchester Airport
    EGSS = 25, // London Stansted Airport
    EGGW = 26, // London Luton Airport
    EGPH = 27, // Edinburgh Airport
    EGBB = 28, // Birmingham Airport
    // EGGD = 29, // Bristol Airport
    EGPF = 30, // Glasgow Airport
    EGAA = 31, // Belfast International Airport
    EGLC = 32, // London City Airport
    // EGNT = 33, // Newcastle Airport
    // EGNX = 34, // East Midlands Airport
    EGAC = 35, // Belfast City Airport
    EGNM = 36, // Leeds Bradford Airport
    EGGP = 37, // Liverpool John Lennon Airport
    // EGPD = 38, // Aberdeen Airport
    EGHI = 39, // Southampton Airport
    // EGJJ = 40, // Jersey Airport
    EGPK = 41, // Glasgow Prestwick Airport
    // EGPE = 42, // Inverness Airport
    EGFF = 43, // Cardiff Airport
    EGTE = 44, // Exeter Airport
    // EGJB = 45, // Guernsey Airport
    // EGHH = 46, // Bournemouth Airport
    // EGSH = 47, // Norwich Airport
    // EGHQ = 48, // Newquay Cornwall Airport
    // EGNS = 49, // Isle of Man Airport
    // EGNV = 50, // Durham Tees Valley Airport
    EGMC = 51, // London Southend Airport
    // EGCN = 52, // Doncaster Sheffield Airport
    // EGPO = 53, // Stornoway Airport
    // EGPB = 54, // Sumburgh Airport
    // EGPA = 55, // Kirkwall Airport
    // EGSC = 56, // Cambridge Airport
    // EGPN = 57, // Dundee Airport
    // EGPL = 58, // Benbecula Airport
    // EGPI = 59, // Islay Airport
    // EGPU = 60, // Tiree Airport
    // EGPR = 61, // Barra Airport
    // EGEC = 62, // Campbeltown Airport
    // EGHC = 63, // Land's End Airport
    // EGHE = 64, // Scilly Isles Airport
    // EGNH = 65, // Blackpool Airport
    // EGAE = 66,  // City of Derry Airport

    // European Union Airports (IDs 67-68)
    EIDW = 67, // Dublin Airport
    EHAM = 68, // Amsterdam Airport Schiphol
}

// Backwards compatibility alias
export { Locations as NZAirports }; 